import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';
import { LoadingScreen } from '../components/LoadingScreen.js';
import { useAuth } from './AuthProvider.js';

/** Renders its children (or the nested outlet) only for signed-in users. */
export function ProtectedRoute({ children }: { children?: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return children ?? <Outlet />;
}
